import axios from "axios";

export function startApplication(transactionId: string, dataPrivacyConsent?:any) {
    const url = process.env.REACT_APP_START_APPLICATION_URL;
    const data = {
        transaction: {
            id: transactionId,
            dataPrivacyConsent: dataPrivacyConsent
        }
    }

    return axios.post(url, data);
}
